var render = function () {
  var _this = this;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "600",
      "height": "100%",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "transition": "dialog-bottom-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "loading": _vm.isLoading,
            "icon": "",
            "data-test-profile-open": ""
          },
          on: {
            "click": _vm.initialize
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-pencil")])], 1)];
      }
    }]),
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: _vm.valid,
      callback: function callback($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title pt-4",
    class: _vm.color
  }, [_c('h4', {
    staticClass: "text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.profile.EditProfileDialog.title")) + " ")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": "",
      "data-test-profile-close": ""
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-divider'), [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-vpn")])], 1), _c('v-list-item-content', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-n4",
    attrs: {
      "outlined": "",
      "label": _vm.$t('components.profile.EditProfileDialog.company'),
      "data-test-profile-company": ""
    },
    model: {
      value: _vm.user.company,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "company", $$v);
      },
      expression: "user.company"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    staticClass: "mt-n4 mb-n4",
    attrs: {
      "outlined": "",
      "label": _vm.$t('components.profile.EditProfileDialog.taxnumber'),
      "data-test-profile-taxnumber": ""
    },
    model: {
      value: _vm.user.taxnumber,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "taxnumber", $$v);
      },
      expression: "user.taxnumber"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  })], _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-account")])], 1), _c('v-list-item-content', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-n4",
    attrs: {
      "outlined": "",
      "label": _vm.$t('components.profile.EditProfileDialog.name'),
      "rules": [function (v) {
        return !!v || _this.$t('components.profile.EditProfileDialog.mandatoryInput');
      }],
      "data-test-profile-firstName": ""
    },
    model: {
      value: _vm.user.firstName,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "firstName", $$v);
      },
      expression: "user.firstName"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-n4",
    attrs: {
      "outlined": "",
      "label": _vm.$t('components.profile.EditProfileDialog.lastname'),
      "rules": [function (v) {
        return !!v || _this.$t('components.profile.EditProfileDialog.mandatoryInput');
      }],
      "data-test-profile-lastName": ""
    },
    model: {
      value: _vm.user.lastName,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "lastName", $$v);
      },
      expression: "user.lastName"
    }
  })], 1)], 1)], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-phone")])], 1), _c('v-list-item-content', [_c('v-text-field', {
    staticClass: "mt-4 mb-n4",
    attrs: {
      "outlined": "",
      "label": _vm.$t('components.profile.EditProfileDialog.phone'),
      "rules": _vm.phoneNumberRules,
      "data-test-profile-phone": ""
    },
    model: {
      value: _vm.user.contact.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.user.contact, "phone", $$v);
      },
      expression: "user.contact.phone"
    }
  })], 1)], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-email")])], 1), _c('v-list-item-content', [_c('v-text-field', {
    staticClass: "mb-n4 mt-n2",
    attrs: {
      "outlined": "",
      "label": _vm.$t('components.profile.EditProfileDialog.email'),
      "rules": _vm.emailRules,
      "data-test-profile-email": ""
    },
    model: {
      value: _vm.user.contact.email,
      callback: function callback($$v) {
        _vm.$set(_vm.user.contact, "email", $$v);
      },
      expression: "user.contact.email"
    }
  })], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-map-marker")])], 1), _c('v-list-item-content', [_c('v-text-field', {
    staticClass: "mt-4 mb-n2",
    attrs: {
      "outlined": "",
      "label": _vm.$t('components.profile.EditProfileDialog.street'),
      "data-test-profile-street": ""
    },
    model: {
      value: _vm.user.address.street,
      callback: function callback($$v) {
        _vm.$set(_vm.user.address, "street", $$v);
      },
      expression: "user.address.street"
    }
  }), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('components.profile.EditProfileDialog.zip'),
      "data-test-profile-zip": ""
    },
    model: {
      value: _vm.user.address.zip,
      callback: function callback($$v) {
        _vm.$set(_vm.user.address, "zip", $$v);
      },
      expression: "user.address.zip"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('components.profile.EditProfileDialog.city'),
      "data-test-profile-city": ""
    },
    model: {
      value: _vm.user.address.city,
      callback: function callback($$v) {
        _vm.$set(_vm.user.address, "city", $$v);
      },
      expression: "user.address.city"
    }
  })], 1)], 1), _c('v-text-field', {
    staticClass: "mt-n4",
    attrs: {
      "outlined": "",
      "label": _vm.$t('components.profile.EditProfileDialog.country'),
      "data-test-profile-state": ""
    },
    model: {
      value: _vm.user.address.state,
      callback: function callback($$v) {
        _vm.$set(_vm.user.address, "state", $$v);
      },
      expression: "user.address.state"
    }
  })], 1)], 1)], 1), _c('v-card-actions', [_c('v-btn', {
    staticClass: "ml-16 mb-6 mt-n4",
    attrs: {
      "disabled": !_vm.valid,
      "loading": _vm.isLoading,
      "outlined": "",
      "large": "",
      "color": "primary",
      "data-test-profile-submit": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-icon', [_vm._v("mdi-content-save")]), _vm._v(" " + _vm._s(_vm.$t("components.profile.EditProfileDialog.btnText")) + " ")], 1), _c('v-spacer')], 1)], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }